import { atom } from "recoil";

export const posEntityAtom = atom<{
    id: string;
    koinz_main_group_id?: string;
    pos_online_payment_method_id?: string;
    offline_only_menu_group_id?: string;
}>({
    key: "posEntityAtom",
    default: {
        id: "",
        koinz_main_group_id: undefined,
        pos_online_payment_method_id: undefined,
        offline_only_menu_group_id: undefined,
    },
});